import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Monitor, formatSchedule } from '../../../../types/monitoring';

interface MonitorListItemProps {
  monitor: Monitor;
  onClick: () => void;
}

export const MonitorListItem: React.FC<MonitorListItemProps> = ({ monitor, onClick }) => {
  const isEnabled = monitor.status === 'enabled';
  const isError = monitor.status === 'error';

  return (
    <button
      id={`monitor-item-${monitor.id}`}
      onClick={onClick}
      aria-label={`View ${monitor.name} monitor details`}
      className="group w-full flex items-center gap-3 p-3 rounded-xl border border-neutral-100 hover:border-neutral-200 hover:bg-neutral-50/50 cursor-pointer transition-all text-left"
    >
      <div className={`w-2 h-2 rounded-full flex-shrink-0 ${
        isEnabled ? 'bg-success-500' : isError ? 'bg-error-500' : 'bg-neutral-300'
      }`} />

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="text-[13px] font-medium text-neutral-900 truncate">{monitor.name}</span>
          {isError && (
            <span className="px-1.5 py-0.5 text-[9px] font-medium rounded bg-error-100 text-error-600">Error</span>
          )}
        </div>
        <div className="flex items-center gap-1.5 mt-0.5">
          {monitor.lead_table_name && (
            <span className="text-[11px] text-neutral-400 truncate max-w-[100px]">
              {monitor.lead_table_name}
            </span>
          )}
          {monitor.lead_table_name && <span className="text-[11px] text-neutral-300">·</span>}
          <span className="text-[11px] text-neutral-400">{formatSchedule(monitor)}</span>
        </div>
      </div>

      <ChevronRight className="w-4 h-4 text-neutral-300 group-hover:text-neutral-400 flex-shrink-0" aria-hidden="true" />
    </button>
  );
};
